import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import Modal from "../Modal";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const ProcessingModal = ({ open, messageText, delay }) => {
  const [delayed, setDelayed] = useState(!!delay);

  useEffect(() => {
    if (open && !!delay) {
      setDelayed(true);
      const timeout = setTimeout(() => setDelayed(false), delay);
      return () => clearTimeout(timeout);
    }
  }, [open, delay]);

  const hideModal = !!delay && delayed;

  return (
    <Modal
      maxWidth="xs"
      open={open && !hideModal}
      dialogContent={
        <Box display="flex" alignItems="center">
          <Box mr={3.5} minWidth={40} height={40}>
            <LoadingSpinner size={40} padding={0} />
          </Box>
          <Box pr={1.5}>
            <Typography color="textSecondary">{messageText}</Typography>
          </Box>
        </Box>
      }
    />
  );
};

export default ProcessingModal;

ProcessingModal.propTypes = {
  open: PropTypes.bool,
  messageText: PropTypes.string,
  /**
   * Delay showing the modal until the provided amount of time has passed
   */
  delay: PropTypes.number
};
